'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

//Element Selections & State
//-----------------------------------------------------------------//

//globals
var $window = $(window);
var $doc = $(document);
var $html = $('html');
var $body = $('body');
var $header = $('#nx-header');
var $footer = $('#nx-footer');
var $main = $('#nx-main');

var $newsletterForm = $('#nx-newsletter-form, #nx-promoblock-form');
var $scrolltolinks = $('[data-scrollto]');
var $accordions = $('.nx-accordion');

//fullwidth sliders
var $fullwidthSliders = $('.nx-fwslider--carousel');

//overlay loadscreen
var $loadscreen = $('#nx-loadscreen');

//navigation
var $navModalToggle = $('#nx-toggle-mainmenu');
var $navModal = $('#nx-menu-overlay');

var $menuDropdowns = $('#nx-menu-dropdowns');
var $menuDropdownsBg = $('#nx-menu-dropdowns-bg');
var $menuParentLinks = $('[data-dropdownmenu]');

var $cartBtn = $('[data-cartpanel-toggle]');
var $cartPanel = $('#nx-cart-outer');
var $cartOverlay = $('#nx-cart-overlay');

//accounts 
var $acctModal = $('#nx-acct-overlay');
var $acctModalToggle = $('#nx-acct-btn');
var $acctModalClose = $('#nx-acctoverlay-close');

//search
var $searchBtn = $('#nx-site-search');
var $searchModal = $('#nx-search-overlay');
var $searchInput = $('#searchbar-input');
var $searchClose = $('#nx-searchbar-close');
var $searchAutoForm = $('form[data-autocomplete]');
var $searchAutoList = $('#nx-autocomplete-list');

//fullscreen section
var $fullscreenSection = $('[data-fullscreen-section]');

//lazy backgroundimg
var $lazyBgImgs = $('[data-lazy-bg]');

//elements to be clip-path'd
var $clipEls = $('[data-clip-path]');

//general overlay
var $overlayTriggers = $('[data-overlay-trigger]');
var $overlaysToAppend = $('[data-overlay-append]');

//price html
var $pricetags = $('[data-pricetag]');
//recipe digit
var $prefixedDigits = $('[data-prefix-digit]');

//modules ---------------------------------------------//

//video poster
var $videoposters = $('.nx-videoposter');
//open plyr modal btns
var $videoPlayBtns = $('[data-video-type="vimeo"], [data-video-type="youtube"]');
var $videoOverlay = $('#nx-vidplayer-overlay');
var $videoEmbedTarget = $('#nx-vidplayer-target');
var $videoClose = $('#nx-vidplayer-close');

//home hero
var $herocarousel = $('#nx-homehero-slider'); //max 1 per-page
var $herocarouselSlides = $herocarousel.find('.nx-homehero--slide');
var $herocarouselMeter = $('#nx-homehero-meter');
var $herocarouselMeterfill = $('#nx-homehero-meter-fill');
var $homeheroControls = $('#nx-homehero-controls');

//product listing tile
var $productListItems = $('[data-productlist-item]');
var $productFilterToggles = $('.nx--filterdrop');
var $prdouctSortDrop = $('.nx--filtersort');
var $productIsogrids = $('[data-isogrid]');
var $productGridPromos = $('.nx-collectionlist--promo');
var $productNotFound = $('#nx-noproduct-match');

//product gateway page
var $productImgLinks = $('.nx-prodpage--imglink');
var $productFullwidthPromo = $('.nx-fwpromo');

//single product page
var $singleProductSlider = $('#nx-product-slider');
var $productsubnav = $('#nx-product-subnav');
var $productsubnavTarget = $('#nx-subnav-target');
var $productSpecModal = $('#nx-productspec-overlay');
var $productFeaturesTop = $('.nx-featurelist--top');
var $productFeaturesBottom = $('.nx-featurelist--bot');

//recipe
var $recipePromo = $('.nx-recipepromo');
var $recipeGrilltips = $('.nx-collectionlist-grilltips');
//tweet block
var $tweetBlock = $('.nx-socialblock');

//blog general
var $readmoreBars = $('.nx-morebar');

//featured story block
var $storyBlockFeature = $('.nx-storyfeature');

//other
var $flickityLazyloads = $('[data-flickity-lazyload], [data-flickity-bg-lazyload]');

var $rtecontent = $('.nx-rte-content');
var $printBtns = $('[data-print-page]');
var $socialShareLinks = $('a[href*="://api.addthis.com/oexchange"]');

var $inviewElements = $('[data-in-view]');

var isShopifyCaptcha = window.location.pathname === '/challenge';
var isAcctPage = $body.hasClass('is-account-page') || isShopifyCaptcha;
var isLoggedIn = $body.hasClass('customer-logged-in');

//EXPORTS --------------------------------------------------//
var s = exports.s = {
	//jquery element cache
	$window: $window, $doc: $doc, $html: $html, $body: $body, $header: $header, $footer: $footer, $main: $main, $newsletterForm: $newsletterForm, $scrolltolinks: $scrolltolinks, $accordions: $accordions, $fullwidthSliders: $fullwidthSliders, $loadscreen: $loadscreen,
	$navModalToggle: $navModalToggle, $navModal: $navModal, $menuDropdowns: $menuDropdowns, $menuDropdownsBg: $menuDropdownsBg, $menuParentLinks: $menuParentLinks,
	$cartBtn: $cartBtn, $cartPanel: $cartPanel, $cartOverlay: $cartOverlay, $acctModal: $acctModal, $acctModalToggle: $acctModalToggle, $acctModalClose: $acctModalClose, $searchBtn: $searchBtn, $searchModal: $searchModal, $searchInput: $searchInput, $searchClose: $searchClose, $searchAutoForm: $searchAutoForm, $searchAutoList: $searchAutoList,
	$fullscreenSection: $fullscreenSection, $lazyBgImgs: $lazyBgImgs, $clipEls: $clipEls, $overlayTriggers: $overlayTriggers, $overlaysToAppend: $overlaysToAppend, $pricetags: $pricetags, $prefixedDigits: $prefixedDigits,
	$videoposters: $videoposters, $videoPlayBtns: $videoPlayBtns, $videoOverlay: $videoOverlay, $videoEmbedTarget: $videoEmbedTarget, $videoClose: $videoClose,
	$herocarousel: $herocarousel, $herocarouselSlides: $herocarouselSlides, $herocarouselMeterfill: $herocarouselMeterfill, $herocarouselMeter: $herocarouselMeter, $homeheroControls: $homeheroControls,
	$productListItems: $productListItems, $productFilterToggles: $productFilterToggles, $prdouctSortDrop: $prdouctSortDrop, $productIsogrids: $productIsogrids, $productGridPromos: $productGridPromos, $productNotFound: $productNotFound,
	$productImgLinks: $productImgLinks, $productFullwidthPromo: $productFullwidthPromo, $singleProductSlider: $singleProductSlider, $productsubnav: $productsubnav,
	$productsubnavTarget: $productsubnavTarget, $productSpecModal: $productSpecModal, $productFeaturesTop: $productFeaturesTop, $productFeaturesBottom: $productFeaturesBottom,
	$recipePromo: $recipePromo, $recipeGrilltips: $recipeGrilltips, $tweetBlock: $tweetBlock, $readmoreBars: $readmoreBars, $storyBlockFeature: $storyBlockFeature, $flickityLazyloads: $flickityLazyloads, $rtecontent: $rtecontent, $printBtns: $printBtns,
	$socialShareLinks: $socialShareLinks, $inviewElements: $inviewElements,

	//state that doesn't change
	gmapsApiKey: 'AIzaSyA8eOjLdF2LroqN_2pnmChHICOrheyK0oU',

	isdev: window.location.hostname === 'dev-nexgrill.myshopify.com',
	islocal: window.location.hostname === 'localhost',
	isstyleguide: $body.hasClass('sg-styleguidepage'),

	isArticle: $body.hasClass('template-article'),

	isacctpage: isAcctPage,
	isLoggedIn: isLoggedIn,
	needsLoaderHidden: isShopifyCaptcha,

	hasherocarousel: !!$herocarousel.length,
	issingleproduct: !!$singleProductSlider.length,

	//tiny lil helpers
	hideElements: function hideElements(els) {
		return els.forEach(function (item) {
			return TweenMax.set(item, { autoAlpha: 0 });
		});
	},

	slidePrevHandler: function slidePrevHandler(flkty) {
		return flkty.selectedIndex === 0 ? flkty.select(flkty.cells.length - 1) : flkty.previous();
	},
	slideNextHandler: function slideNextHandler(flkty) {
		return flkty.selectedIndex === flkty.cells.length - 1 ? flkty.select(0) : flkty.next();
	},

	digitPrefixer: function digitPrefixer(digit) {
		var strdigit = digit.toString();
		return strdigit.length > 1 ? strdigit : '0' + strdigit;
	},

	randomInt: function randomInt(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	},

	quickWrite: function quickWrite(callback) {
		return requestAnimationFrame(callback);
	}
};

//state that changes
var _s = exports._s = {
	didScroll: true,

	winHeight: $window.height(),
	winWidth: $window.width(),

	scrollCurrent: window.pageYOffset,
	scrollPrev: 0,
	scrollDiff: 0,

	headerHeight: $header.outerHeight(),

	menuOverlayShowing: false,
	menuDropdownShowing: false,
	acctOverlayShowing: false,
	searchOverlayShowing: false,
	accountOverlayShowing: false,
	cartPanelShowing: false
};

//slider utils
var slider = exports.slider = {
	//get a slider arrow (jquery selection)
	// type = "Next" or "Prev"
	getSliderBtnHtml: function getSliderBtnHtml(type, id) {
		var typelower = type.toLowerCase();
		var arrowPath = typelower === 'next' ? '<path d="M1720,1049v-1h-39v1h39Zm-1.35-.65,0.7-.7-5-5-0.7.7Zm0.7,1-0.7-.7-5,5,0.7,0.7Z" transform="translate(-1681 -1042.66)"/>' : '<path d="M83,1048v-1h39v1H83Zm1.353-.65-0.707-.7,5-5,0.707,0.7Zm-0.707,1,0.707-.7,5,5-0.707.7Z" transform="translate(-83 -1041.66)"/>';
		var html = '<button id="' + id + '" class="nx-sliderbtn nx-sliderbtn--' + typelower + '">\n\t\t\t\t\t\t\t\t\t\t<span class="nx-sliderbtn--text"><span>' + type + '</span></span>\n\t\t\t\t\t\t\t\t\t\t<span class="nx-sliderbtn--arrow">\n\t\t\t\t\t\t\t\t\t\t\t<svg xmlns="http://www.w3.org/2000/svg" width="39" height="11.68" viewBox="0 0 39 11.68">' + arrowPath + '</svg>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<span class="nx-sliderbtn--circle">\n\t\t\t\t\t\t\t\t\t\t\t<svg width="38" height="38" viewBox="0 0 38 38">\n\t\t\t\t\t\t\t  \t\t\t\t<circle cx="19" cy="19" r="18"/>\n\t\t\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</button>';
		return $(html);
	},

	getSliderCounter: function getSliderCounter(flkty) {
		var html = '<div class="nx-slider--counter">\n\t\t\t\t\t\t\t\t\t\t<span class="nx-slider--counter-sep">|</span>\n\t\t\t\t\t\t\t\t\t\t<span class="nx-slider--counter-total">' + s.digitPrefixer(flkty.slides.length) + '</span>\n\t\t\t\t\t\t\t\t\t</div>';
		var $current = $('<span class="nx-slider--counter-current">' + s.digitPrefixer(flkty.selectedIndex + 1) + '</span>');
		return { $current: $current, html: html };
	},

	updateSliderCounter: function updateSliderCounter($el, num, flkty) {
		if (flkty && flkty.selectedIndex) return;

		TweenMax.to($el, 0.15, { rotationX: 90, onComplete: function onComplete() {
				$el.text(s.digitPrefixer(num));
				TweenMax.set($el, { rotationX: -90 });
				TweenMax.to($el, 0.15, { autoAlpha: 1, rotationX: 0 });
			} });
	}
};

//need to detect IE since it doesn't support clip-paths
var detectIE = exports.detectIE = function detectIE() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return false;
};

//check for clip-path support
var supportsClipPath = exports.supportsClipPath = function supportsClipPath() {
	var base = 'clipPath',
	    prefixes = ['webkit', 'moz', 'ms', 'o'],
	    properties = [base],
	    testElement = document.createElement('testelement'),
	    attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

	// Push the prefixed properties into the array of properties.
	for (var i = 0, l = prefixes.length; i < l; i++) {
		var prefixedProperty = prefixes[i] + base.charAt(0).toUpperCase() + base.slice(1); // remember to capitalize!
		properties.push(prefixedProperty);
	}
	// Interate over the properties and see if they pass two tests.
	for (var i = 0, l = properties.length; i < l; i++) {
		var property = properties[i];

		// First, they need to even support clip-path (IE <= 11 does not)...
		if (testElement.style[property] === '') {

			// Second, we need to see what happens when we try to create a CSS shape...
			testElement.style[property] = attribute;
			if (testElement.style[property] !== '') {
				return true;
			}
		}
	}
	return false;
};


//////////////////
// WEBPACK FOOTER
// ./_js/setup.js
// module id = 0
// module chunks = 0